import { Box, Hidden, Stack, Typography } from "@mui/material";
import { AccountCircle } from "@mui/icons-material";

import MenuButtonExtended from "../../common/components/mui-extended/MenuButtonExtended";
import { PublicRoutesConfig, CommonRoutesConfig } from "../RoutesConfig";
import useUserContext from "../../hooks/useUserContext";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Header() {
  const { name, isAuthenticated } = useUserContext();
  const location = useLocation();

  const options = [
    {
      label: PublicRoutesConfig.Profile.Label,
      link: PublicRoutesConfig.Profile.Path,
      icon: PublicRoutesConfig.Profile.Icon,
    },
  ];
  options.push({
    label: CommonRoutesConfig.Logout.Label,
    link: CommonRoutesConfig.Logout.Path,
    icon: CommonRoutesConfig.Logout.Icon,
  });

  useEffect(() => {}, [location]);

  return (
    <Stack direction="row" justifyContent="stretch" width="100%">
      <Typography
        component="span"
        fontWeight={800}
        fontSize={21}
        marginTop="auto"
        marginLeft={1}
        marginBottom="auto"
        color="white"
      >
        <Hidden mdDown>Електронен регистър </Hidden>
        "Единство"
      </Typography>
      <Box sx={{ flexGrow: 1 }} />
      {isAuthenticated && (
        <Box p={1}>
          <MenuButtonExtended label={name} icon={<AccountCircle />} options={options} />
        </Box>
      )}
    </Stack>
  );
}
